import React, { useState, useEffect, useRef } from 'react';
import { Form, Container, Row, Col, Image, Button } from 'react-bootstrap';
import { Title, Content, Styles } from '../../../style/content';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBuilding, faCity, faDollarSign } from '@fortawesome/free-solid-svg-icons';
import { CardsData } from './dashboard.interface';
import { dashboardService } from 'src/services/GC/dashboardService';

const Dashboard: React.FC = () => {
  const [cardsData, setCardsData] = useState({} as CardsData);

  useEffect(() => {
    getCardsData();
  }, []);

  const getCardsData = async () => {
    const result = await dashboardService.cardsData();
    if (result) {
      setCardsData(result);
    } else {
      console.log(result.message);
    }
  };

  return (
    <>
      <Title>Bem-vindo!</Title>

      <Content>
        <Container fluid className='card-no-tabs dashboardGM'>
          <Row>
              <Col
                className='d-flex justify-content-around'
                md={4}
              >
                <div className='status_card'>
                  <p>
                    <FontAwesomeIcon
                      size='3x'
                      icon={faBuilding}
                      color='#FFF'
                    />
                  </p>
                  <h1 className='title'>{cardsData.clientsTotal}</h1>
                  <h3 className='sub_title'>Total de clientes</h3>
                </div>
              </Col>

              <Col
                    className='d-flex justify-content-around'
                    md={4}
                  >
                    <div className='status_card'>
                      <p>
                        <FontAwesomeIcon
                          size='3x'
                          icon={faDollarSign}
                          color='#FFF'
                        />
                      </p>
                      <h1 className='title'>{cardsData.clientsTotalBalance}</h1>
                      <h3 className='sub_title'>Limite de saldo total dos clientes</h3>
                    </div>
                  </Col>

              <Col
                className='d-flex justify-content-around'
                md={4}
              >
                <div className='status_card'>
                  <p>
                    <FontAwesomeIcon
                      size='3x'
                      icon={faCity}
                      color='#FFF'
                    />
                  </p>
                  <h1 className='title'>{cardsData.clientsTotalLastMonth}</h1>
                  <h3 className='sub_title'>Clientes registados no último mês</h3>
                </div>
              </Col>
          </Row>
          
        </Container>
      </Content>
    </>
  );
};

export default Dashboard;
